import {generateBannersMap} from '../../modules/banner/bannerUtils';

function generateDefaultInitialBannerState() {
  return {
    categoryBannersMap: null,
    searchBannersMap: null,
    tagBannersMap: null,
  };
}

function bannerReducer(state = generateDefaultInitialBannerState(), action) {
  let newState;

  switch (action.type) {
    case 'GET_CATEGORY_BANNERS_FULFILLED': {
      newState = {
        ...state,
        categoryBannersMap: generateBannersMap(
          action.payload.response.data.data
        ),
      };

      break;
    }

    case 'GET_SEARCH_BANNERS_FULFILLED': {
      newState = {
        ...state,
        searchBannersMap: generateBannersMap(
          action.payload.response.data.data
        ),
      };

      break;
    }

    case 'GET_TAG_BANNERS_FULFILLED': {
      newState = {
        ...state,
        tagBannersMap: generateBannersMap(
          action.payload.response.data.data
        ),
      };

      break;
    }

    case 'RESET_BANNER_STATE': {
      newState = generateDefaultInitialBannerState();

      break;
    }

    case 'LEAVE_SEARCH_PAGE_ROUTE': {
      newState = {
        ...state,
        searchBannersMap: null,
      };

      break;
    }
    case 'LEAVE_BRAND_CATEGORY_PAGE_ROUTE':
    case 'LEAVE_CATEGORY_PAGE_ROUTE': {
      newState = {
        ...state,
        categoryBannersMap: null,
      };

      break;
    }

    default:
      newState = state;
  }

  return newState;
}

export default bannerReducer;
export {
  generateDefaultInitialBannerState,
};
